const doc = [({"en":({"js":({"admin":({"activities":({"index":({"add_new_activity":"Add new activity"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;